import { Link } from "react-router-dom";
import { CalendarCheck2 } from "lucide-react";
import { MeetingBadge } from "@/components/Badges";
import { label, fmtDT } from "@/lib/constants";

export const MeetingRow = ({ m, onLog, showLead = false }) => {
  const actionable = ["SCHEDULED", "IN_PROGRESS", "PENDING_DISPOSITION"].includes(m.state);
  return (
    <div data-testid={`meeting-row-${m.id}`} className={`rounded-2xl border p-4 ${m.state === "PENDING_DISPOSITION" ? "border-rose-300 bg-rose-50" : "border-neutral-200 bg-white"}`}>
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          {showLead && <Link to={`/leads/${m.lead.id}`} className="block truncate font-medium text-[#1A1A1A] hover:text-[#1F9E7A]">{m.lead.full_name} <span className="text-neutral-400">· {m.lead.company_name || "—"}</span></Link>}
          <p className="text-sm font-medium text-neutral-800">{label(m.meeting_type)} <span className="text-neutral-400">· {label(m.channel)}</span></p>
          <p className="font-mono text-xs text-neutral-500">{fmtDT(m.scheduled_start)} → {fmtDT(m.scheduled_end).split(", ")[1]}</p>
        </div>
        <MeetingBadge state={m.state} testId={`meeting-state-${m.id}`} />
      </div>
      {m.meeting_outcome && <p className="mt-2 text-xs text-emerald-700">Outcome: {label(m.meeting_outcome)}</p>}
      {m.meeting_notes && <p className="mt-1 text-xs text-neutral-500">{m.meeting_notes}</p>}
      {m.meeting_type === "TECH_DEMO" && m.lead?.website_demo_url && <a href={m.lead.website_demo_url} target="_blank" rel="noreferrer" className="mt-2 inline-block text-sm font-medium text-[#137A5E] underline">Open demo link</a>}
      {m.escalated && m.state === "PENDING_DISPOSITION" && <p className="mt-1 text-xs font-semibold text-rose-700">Escalated · 30+ min past end</p>}
      {m.rescheduled_from && <p className="mt-1 font-mono text-[10px] text-purple-700">↻ rescheduled from earlier slot</p>}
      {m.google_event_id && (
        <a href={m.google_event_link || undefined} target="_blank" rel="noreferrer" data-testid={`meeting-gcal-${m.id}`} className="mt-1 inline-flex items-center gap-1 rounded-full bg-[#E6F5EF] px-2 py-0.5 text-[10px] font-semibold text-[#137A5E]">
          <CalendarCheck2 className="h-3 w-3" />Synced to Google Calendar{m.client_rsvp ? ` · RSVP ${m.client_rsvp}` : ""}
        </a>
      )}
      {actionable && (
        <button data-testid={`meeting-log-btn-${m.id}`} onClick={onLog} className={`mt-3 h-10 w-full rounded-lg text-sm font-semibold ${m.state === "PENDING_DISPOSITION" ? "bg-rose-500 text-white" : "border border-neutral-200 text-neutral-800 hover:border-neutral-400"}`}>
          {m.state === "SCHEDULED" ? "Reschedule / Cancel" : "Log outcome"}
        </button>
      )}
    </div>
  );
};
